

import React, { useState } from "react";
import { Button, Card, CardHeader, CardBody, Input, Row, Col, CardTitle } from "reactstrap";
import useToken from "../../helpers/useToken"
import TMHLoader from "../TMHLoader/TMHLoader";

export default function IPTable() {
    const { token } = useToken()
    const [IPsAddress, setIPsAddress] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const removeIPs = () => {
        setIsLoading(true)
        console.log('IPRemove: remove ip: ' + IPsAddress)
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);

        let ips = IPsAddress.split(" ")

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'ips': ips
            })
        }

        fetch(process.env.REACT_APP_BASE_URL + "IPs/remove", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    console.log(json)
                    if (result.ok) {
                        var text = "Remove IPs success:"
                        for (let i = 0; i < ips.length; i++) {
                            text += "\n" + ips[i] + " - removed " + json.data[i] + " records";
                        }
                        window.alert(text)
                    }
                    else {
                        window.alert("ERROR")
                    }
                }
            ).finally(() => setIsLoading(false))
    }


    return (

        <TMHLoader active={isLoading}>
            <Card>
                <CardBody>
                    <Row className="mb-2">
                        <Col md="8">
                            <Input
                                style={{ height: 45 }}
                                placeholder="Input IPs to remove, split by white space"
                                type="text"
                                value={IPsAddress}
                                onChange={(e) => {
                                    setIPsAddress(e.target.value)
                                }}
                            />
                        </Col>
                        <Col md="4">
                            <Col md="12">
                                <Button
                                    onClick={() => removeIPs()}
                                    color="success">Remove</Button>
                            </Col>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </TMHLoader>
    );
}